export default __webpack_public_path__ + "static/media/t3.79c8ba88.jpg";